export default {
  type: "FeatureCollection",
  name: "visi",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {
        OBJECTID: 1,
        Adrese_1:
          "Bērzu gatve 9, Kazdanga, Kazdangas pagasts, Dienvidkurzemes novads, Latvija, LV-3457",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/sia-ruksi-kazdangas-miesnieks",
        Nosaukum_1: "SIA Rukši – Kazgangas Miesnieks",
      },
      geometry: {
        type: "Point",
        coordinates: [21.728671999832088, 56.717762000162814],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 2,
        Adrese_1:
          "Būmeistari, Tārgales pagasts, Ventspils novads, Latvija, LV-3621",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/iu-berka-lauku-seta-klingeri-jana-berka-lauku-seta-klingeri",
        Nosaukum_1: "IU Berka lauku sēta Kliņģeri, Jana Berka",
      },
      geometry: {
        type: "Point",
        coordinates: [21.658580999712459, 57.341639999691793],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 3,
        Adrese_1: "Drubazas, Abavas pagasts, Talsu novads, Latvija, LV-3294",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-drubazas",
        Nosaukum_1: "ZS Drubazas",
      },
      geometry: {
        type: "Point",
        coordinates: [22.596375999494573, 57.030315000116445],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 4,
        Adrese_1:
          "Priedītes, Kandavas pagasts, Tukuma novads, Latvija, LV-3120",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/sia-viss-lv-lindas-keramikas-darbnica",
        Nosaukum_1: "SIA Viss.lv – Lindas keramikas darbnīca",
      },
      geometry: {
        type: "Point",
        coordinates: [22.734565999202434, 57.014960999659749],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 5,
        Adrese_1:
          "Vidnieki, Antiņciems, Lapmežciema pagasts, Tukuma novads, Latvija, LV-3118",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/sanita-matule-sanitas-plavas-veltes-dare-atputies-plava",
        Nosaukum_1:
          "Sanita Matule – Sanitas Pļavas veltes, DARE atpūties pļavā",
      },
      geometry: {
        type: "Point",
        coordinates: [23.460665000201512, 56.97738300015132],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 6,
        Adrese_1:
          "Ābeļu iela 7, Zemkopības institūts, Skrīveru pagasts, Aizkraukles novads, Latvija, LV-5125",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/janis-vigovskis",
        Nosaukum_1: "Jānis Vigovskis",
      },
      geometry: {
        type: "Point",
        coordinates: [25.115284000213762, 56.629531999735597],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 7,
        Adrese_1: "Kaltiņi, Suntažu pagasts, Ogres novads, Latvija, LV-5060",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/sia-starspace-zvaigznu-aitas",
        Nosaukum_1: "SIA StarSpace –  Zvaigžņu aitas",
      },
      geometry: {
        type: "Point",
        coordinates: [24.958450000465337, 56.895163999810755],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 8,
        Adrese_1:
          "Virbotnes 2, Limbažu pagasts, Limbažu novads, Latvija, LV-4020",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/ik-pilnveido-sevi-virbotnu-kazas",
        Nosaukum_1: "IK Pilnveido sevi – Virbotņu kazas",
      },
      geometry: {
        type: "Point",
        coordinates: [24.564130999444586, 57.510452000007497],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 9,
        Adrese_1: "Atēnas, Zaubes pagasts, Cēsu novads, Latvija, LV-4113",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-atenas",
        Nosaukum_1: "ZS Atēnas",
      },
      geometry: {
        type: "Point",
        coordinates: [25.369367999844432, 56.9713550000833],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 10,
        Adrese_1:
          "Annas Ozoliņi, Zaubes pagasts, Cēsu novads, Latvija, LV-4113",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-ozolini-lauku-teja",
        Nosaukum_1: "ZS Ozoliņi – Lauku tēja",
      },
      geometry: {
        type: "Point",
        coordinates: [25.41109299980716, 57.036029999662446],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 11,
        Adrese_1: "Ozoli, Vaidavas pagasts, Valmieras novads, Latvija, LV-4228",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/elizabete-bendika-bendiku-piena-aitas",
        Nosaukum_1: "Elizabete Bendika – Bendiku Piena Aitas",
      },
      geometry: {
        type: "Point",
        coordinates: [25.296787000705027, 57.447322999650254],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 12,
        Adrese_1: "Tauri, Ērgļu pagasts, Madonas novads, Latvija, LV-4840",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/sia-tauri-sia-3dpro-negantigardi",
        Nosaukum_1: "SIA Tauri, SIA 3Dpro – NEGANTIgardi",
      },
      geometry: {
        type: "Point",
        coordinates: [25.596293999591996, 56.882103000404015],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 13,
        Adrese_1:
          "Pilsgravas, Ķoņu pagasts, Valmieras novads, Latvija, LV-4240",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/alise-zarina",
        Nosaukum_1: "Alise Zariņa",
      },
      geometry: {
        type: "Point",
        coordinates: [25.371749999869632, 57.881648999911292],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 14,
        Adrese_1:
          "Stirnas, Smiltenes pagasts, Smiltenes novads, Latvija, LV-4729",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-stirnas",
        Nosaukum_1: "ZS Stirnas",
      },
      geometry: {
        type: "Point",
        coordinates: [25.812255999345105, 57.453944999570588],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 15,
        Adrese_1: "Labumi, Bērzaunes pagasts, Madonas novads, Latvija, LV-4853",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/ieva-galina-lat-angus",
        Nosaukum_1: "Ieva Galiņa – Lat Angus",
      },
      geometry: {
        type: "Point",
        coordinates: [26.032994999450324, 56.792709000059446],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 16,
        Adrese_1:
          "Kalna Rubeņi, Praulienas pagasts, Madonas novads, Latvija, LV-4825",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-kalna-rubeni",
        Nosaukum_1: "ZS Kalna Rubeņi",
      },
      geometry: {
        type: "Point",
        coordinates: [26.265498999922162, 56.841742999899651],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 17,
        Adrese_1:
          "Uzkalni, Mētrienas pagasts, Madonas novads, Latvija, LV-4865",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-priezukalns",
        Nosaukum_1: "ZS Priežukalns",
      },
      geometry: {
        type: "Point",
        coordinates: [26.35023100066779, 56.661876999541882],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 18,
        Adrese_1:
          "Silmalas, Litenes pagasts, Gulbenes novads, Latvija, LV-4405",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/sia-sita-nature-park",
        Nosaukum_1: "SIA Sita Nature Park",
      },
      geometry: {
        type: "Point",
        coordinates: [27.008428999586453, 57.163241999874465],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 19,
        Adrese_1:
          "Upmalas, Viecināni, Mežvidu pagasts, Ludzas novads, Latvija, LV-5725",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-upmalas",
        Nosaukum_1: "ZS Upmalas",
      },
      geometry: {
        type: "Point",
        coordinates: [27.598901999582818, 56.617095999582219],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 20,
        Adrese_1:
          "Bites, Savelinki, Zaļesjes pagasts, Ludzas novads, Latvija, LV-5751",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/jurijs-ilga-janis-ivanovi-apskates-saimnieciba-bites",
        Nosaukum_1: "Jurijs, Ilga, Jānis Ivanovi – Apskates saimniecība Bites",
      },
      geometry: {
        type: "Point",
        coordinates: [28.131635999455131, 56.397372999875259],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 21,
        Adrese_1:
          "Ugāles 5, Piltenes pagasts, Ventspils novads, Latvija, LV-3620",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-bisudarzi",
        Nosaukum_1: "ZS Bišudārzi",
      },
      geometry: {
        type: "Point",
        coordinates: [21.81941666666685, 57.222222222222214],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 22,
        Adrese_1: "Kroķi, Matkules pagasts, Tukuma novads, Latvija, LV-3132",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-lejaskroki",
        Nosaukum_1: "ZS Lejaskroķi",
      },
      geometry: {
        type: "Point",
        coordinates: [22.640638888888891, 57.000805555555537],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 23,
        Adrese_1:
          "Ezernieki 1, Druvienas pagasts, Gulbenes novads, Latvija, LV-4426",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/sia-laskumi",
        Nosaukum_1: "SIA Laskumi",
      },
      geometry: {
        type: "Point",
        coordinates: [26.288916666666413, 57.110166666666672],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 24,
        Adrese_1: "Pavasari, Remtes pagasts, Saldus novads, Latvija, LV-3871",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/sia-pavasari-rt",
        Nosaukum_1: "SIA Pavasari RT",
      },
      geometry: { type: "Point", coordinates: [22.658305555555561, 56.73225] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 25,
        Adrese_1:
          "Lejnieki, Brunavas pagasts, Bauskas novads, Latvija, LV-3907",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/iluta-strage-piena-aitas-bio",
        Nosaukum_1: "Iluta Straģe – Piena aitas bio",
      },
      geometry: {
        type: "Point",
        coordinates: [24.399333333333331, 56.355555555555561],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 26,
        Adrese_1:
          "Vingri, Vingri, Rožkalnu pagasts, Preiļu novads, Latvija, LV-5325",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/janis-vingris",
        Nosaukum_1: "Jānis Vingris",
      },
      geometry: {
        type: "Point",
        coordinates: [26.462083333332963, 56.20902777777777],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 27,
        Adrese_1: "Daugavieši, Dunavas pagasts, Jēkabpils novads, LV-5216",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/anita-ozolina",
        Nosaukum_1: "Anita Ozoliņa",
      },
      geometry: {
        type: "Point",
        coordinates: [26.210444444444271, 56.217527777777789],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 28,
        Adrese_1:
          "Meža iela 1, Elkšņi, Elkšņu pagasts, Jēkabpils novads, LV-5217",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/laura-cernauska-krakta",
        Nosaukum_1: "Laura Černauska-Krakta",
      },
      geometry: {
        type: "Point",
        coordinates: [25.577388888888869, 56.213972222222225],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 29,
        Adrese_1: "Ozolāji, Dvietes pagasts, Augšdaugavas novads, LV-5441",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/atis-stapkevics-dvietes-istais-lauku-saldejums",
        Nosaukum_1: "Atis Stapkevičs - Dvietes īstais lauku saldējums",
      },
      geometry: { type: "Point", coordinates: [26.199277777777617, 56.07875] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 30,
        Adrese_1: "Ābelītes, Bukaišu pagasts, Dobeles novads, Latvija, LV-3714",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/sia-elite-plus",
        Nosaukum_1: "SIA Elite Plus",
      },
      geometry: { type: "Point", coordinates: [23.179887, 56.43318] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 31,
        Adrese_1:
          "Līdumkalni, Ķurbe, Īves pagasts, Talsu novads, Latvija, LV-3261",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/vizma-sulca",
        Nosaukum_1: "Vizma Šulca",
      },
      geometry: { type: "Point", coordinates: [22.520818, 57.495545] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 32,
        Adrese_1:
          "Dārzniecības iela 4a, Tukums, Tukuma novads, Latvija, LV-3101",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/kristine-zihmane-ritina-salmu-muzejs-darbnica",
        Nosaukum_1: "Kristīne Zihmane-Rītiņa - Salmu muzejs, darbnīca",
      },
      geometry: { type: "Point", coordinates: [23.16, 56.967827] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 33,
        Adrese_1: "Dāri, Tumes pagasts, Tukuma novads, Latvija, LV-3139",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/dainis-erbss-daru-kazu-siers",
        Nosaukum_1: "Dainis Erbss - Dāru kazu siers",
      },
      geometry: { type: "Point", coordinates: [23.034, 56.881866] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 34,
        Adrese_1:
          "Graudiņi, Sakas pagasts, Dienvidkurzemes novads, Latvija, LV-3466",
        Saite:
          "https://dabiskoplavuprodukts.lv/razotaji/inese-dimanta-bisu-dravas-ire",
        Nosaukum_1: "Inese Dimanta - Bišu dravas īre",
      },
      geometry: { type: "Point", coordinates: [21.184000000001078, 56.824883] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 35,
        Adrese_1: "Auļi, Pūres pagasts, Tukuma novads, Latvija, LV-3122",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-auli",
        Nosaukum_1: "ZS Auļi",
      },
      geometry: { type: "Point", coordinates: [22.92, 57.084476] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 36,
        Adrese_1:
          "Janavas, Kokneses pagasts, Aizkraukles novads, Latvija, LV-5113",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-janavas",
        Nosaukum_1: "ZS Janavas",
      },
      geometry: { type: "Point", coordinates: [25.358, 56.629208] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 37,
        Adrese_1:
          "Vīcepi, Jaunklidzis, Plāņu pagasts, Valmieras novads, Latvija, LV-4727",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-vicepi-1",
        Nosaukum_1: "ZS Vīcepi 1",
      },
      geometry: { type: "Point", coordinates: [25.779, 57.581005] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 38,
        Adrese_1:
          "Silvas, Brīvzemnieku pagasts, Limbažu novads, Latvija, LV-4063",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-silvas",
        Nosaukum_1: "ZS SIlvas",
      },
      geometry: { type: "Point", coordinates: [25.014, 57.655289] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 39,
        Adrese_1: "Raiņa iela 20, Gulbene, Gulbenes novads, Latvija, LV-4401",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/anda-laicane",
        Nosaukum_1: "Anda Laicāne",
      },
      geometry: { type: "Point", coordinates: [26.743999999999062, 57.171047] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 40,
        Adrese_1: "Ramuļēni, Ērgļu pagasts, Madonas novads, Latvija, LV-4840",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-ramuleni",
        Nosaukum_1: "ZS Ramuļēni",
      },
      geometry: { type: "Point", coordinates: [25.605, 56.917248] },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 40,
        Adrese_1: "Ramuļēni, Ērgļu pagasts, Madonas novads, Latvija, LV-4840",
        Saite: "https://dabiskoplavuprodukts.lv/razotaji/zs-ramuleni",
        Nosaukum_1: "ZS Ramuļēni",
      },
      geometry: {
        type: "Point",
        coordinates: [25.605, 56.917248],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 41,
        Adrese_1: "Lieļi, Straupes pagasts, Cēsu novads, Latvija, LV-4152",
        Saite:
          "https://dabiskoplavuprodukts.lv/plavas-produkti/dzintra-elberte/",
        Nosaukum_1: "Dzintra Elberte",
      },
      geometry: {
        type: "Point",
        coordinates: [25.029, 57.266933],
      },
    },
    {
      type: "Feature",
      properties: {
        OBJECTID: 42,
        Adrese_1: "Vecķiguļi, Plāņu pagasts, Valmieras novads, LV-4727",
        Saite: "https://dabiskoplavuprodukts.lv/plavas-produkti/zs-veckiguli/",
        Nosaukum_1: "ZS Vecķiguļi",
      },
      geometry: {
        type: "Point",
        coordinates: [25.810056, 57.601528],
      },
    },
  ],
};
